import axios from "../../adminCompenents/config/axiosConfig";

export default class AdresseService {
  // 🔹 Récupérer toutes les adresses
  getAllAdresses = async () => {
    try {
      const response = await axios.get("/adresses");
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération des adresses : " + error.message
      );
    }
  };

  // 🔹 Créer une nouvelle adresse
  createAdresse = async (data) => {
    try {
      const response = await axios.post("/adresses", data);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de l'adresse : " + error.message
      );
    }
  };

  // 🔹 Modifier une adresse existante
  editAdresse = async (id, data) => {
    try {
      const response = await axios.patch(`/adresses/${id}`, data);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la modification de l'adresse : " + error.message
      );
    }
  };

  // 🔹 Récupérer une adresse par ID
  getAdresseById = async (id) => {
    try {
      const response = await axios.get(`/adresses/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération de l'adresse : " + error.message
      );
    }
  };

  // 🔹 Supprimer une adresse
  deleteAdresse = async (id) => {
    try {
      const response = await axios.delete(`/adresses/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la suppression de l'adresse : " + error.message
      );
    }
  };

  // 🔹 Récupérer les adresses d’un utilisateur spécifique
  getAdressesByUser = async (userId) => {
    try {
      const response = await axios.get(`/adresses/user/${userId}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération des adresses de l'utilisateur : " +
          error.message
      );
    }
  };
}
